import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applyRealityCheckQueries(message) {
    return applyRESTQueries(ConnectionNames.realityCheck, message);
}
//# sourceMappingURL=ApplyRealityCheckQueries.js.map